/**
 * Error Handler Utility
 * Centralized error handling and logging
 */

import { ERROR_MESSAGES } from '../config/constants'
import { captureException } from './monitoring'

/**
 * Logs error to console (in development) and reports to error tracking when configured
 */
export const logError = (error, context = {}) => {
  const errorInfo = {
    message: error?.message,
    stack: error?.stack,
    context,
    timestamp: new Date().toISOString(),
  }

  if (import.meta.env.DEV) {
    console.error('Error occurred:', errorInfo)
  }

  captureException(error, { ...context, type: 'logError' })
  return errorInfo
}

/**
 * Formats error message for user display
 */
export const formatErrorMessage = (error) => {
  if (typeof error === 'string') {
    return error
  }
  
  if (error?.message) {
    return error.message
  }
  
  if (error?.response?.data?.error) {
    return error.response.data.error
  }
  
  if (error?.response?.data?.message) {
    return error.response.data.message
  }
  
  return ERROR_MESSAGES.GENERIC_ERROR
}

/**
 * Handles API errors
 */
export const handleApiError = (error) => {
  logError(error, { type: 'API_ERROR' })
  
  // Network errors
  if (error.message.includes('fetch') || error.message.includes('Network')) {
    return ERROR_MESSAGES.NETWORK_ERROR
  }
  
  // Timeout errors
  if (error.message.includes('timeout')) {
    return 'Request timed out. Please try again.'
  }
  
  // Server errors
  if (error.status >= 500) {
    return 'Server error. Please try again later.'
  }
  
  // Client errors (400-499)
  if (error.status >= 400) {
    return formatErrorMessage(error)
  }
  
  // Generic error
  return formatErrorMessage(error) || ERROR_MESSAGES.GENERIC_ERROR
}
